import React from 'react';
import { Link } from 'react-router-dom';

function formatDate(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
}

function ScorePill({ attempt }) {
  const pct = attempt.result?.percentage;
  const correct = attempt.result?.correct;
  const total = attempt.result?.totalItems;
  if (pct == null) return <span className="font-inter font-regular text-[14px] text-[#181D1FBF]">—</span>;
  return (
    <span className="font-inter font-regular text-[14px] text-[#45464E80]">
      <span className="text-[#181D1FBF]">{pct.toFixed(2)}%</span>
      {correct != null && total != null ? ` (${correct}/${total})` : ''}
    </span>
  );
}


export default function RecentAttempts({ attempts, loading, reviewerTitle, noPadding, largeHeading }) {
  const wrapClass = `bg-white rounded-[12px]${noPadding ? '' : ' p-[20px] sm:p-[24px]'}`;
  const headingClass = largeHeading
    ? 'font-inter font-bold text-[24px] text-[#45464E] mb-5'
    : 'font-inter font-semibold text-[16px] text-[#45464E] mb-[24px]';

  if (loading) {
    return (
      <div className={wrapClass}>
        <div className="h-[20px] w-[160px] bg-[#F1F3F5] rounded animate-pulse mb-[16px]" />
        {[...Array(4)].map((_, i) => (
          <div key={i} className="h-[44px] bg-[#F1F3F5] rounded animate-pulse mb-[8px]" />
        ))}
      </div>
    );
  }

  if (!attempts || attempts.length === 0) {
    return (
      <div className={wrapClass}>
        <h2 className={headingClass}>Recent Attempts</h2>
        <p className="font-inter text-[14px] text-[#6C737F]">
          You haven't taken any exams yet. Start an exam to see your history here.
        </p>
      </div>
    );
  }

  return (
    <div className={wrapClass}>
      <h2 className={headingClass}>Recent Attempts</h2>

      {/* Desktop table */}
      <div className="hidden sm:block overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-[#181D1F26] bg-[#F5F5F6]">
              <th className="font-inter font-bold text-[14px] text-[#45464E] text-left py-[15px] px-[16px]">Exam</th>
              <th className="font-inter font-bold text-[14px] text-[#45464E] text-left py-[15px] px-[16px]">Score</th>
              <th className="font-inter font-bold text-[14px] text-[#45464E] text-left py-[15px] px-[16px]">Time</th>
              <th className="font-inter font-bold text-[14px] text-[#45464E] text-left py-[15px] px-[16px]">Date</th>
              <th className="font-inter font-bold text-[14px] text-[#45464E] text-left py-[15px] px-[16px]">Action</th>
            </tr>
          </thead>
          <tbody>
            {attempts.map((attempt) => (
              <tr key={attempt._id} className="border-b border-[#181D1F1A] last:border-0">
                <td className="py-[12px] px-[16px]">
                  <span className="font-inter font-regular text-[14px] text-[#181D1F]">
                    {attempt.reviewer?.title || reviewerTitle || 'Exam'}
                  </span>
                </td>
                <td className="py-[12px] px-[16px]">
                  <ScorePill attempt={attempt} />
                </td>
                <td className="py-[12px] px-[16px]">
                  <span className="font-inter font-regular text-[14px] text-[#181D1FBF]">
                    {attempt.timeTaken || '—'}
                  </span>
                </td>
                <td className="py-[12px] px-[16px]">
                  <span className="font-inter font-regular text-[14px] text-[#181D1FBF]">
                    {formatDate(attempt.submittedAt || attempt.createdAt)}
                  </span>
                </td>
                <td className="py-[12px] px-[16px]">
                  <Link
                    to={`/dashboard/results/${attempt._id}`}
                    className="font-inter font-regular text-[14px] text-[#6E43B9] underline"
                  >
                    View
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="sm:hidden space-y-[10px]">
        {attempts.map((attempt) => (
          <div key={attempt._id} className="border border-[#E8EAED] rounded-[10px] p-[14px]">
            <div className="flex items-start justify-between gap-[8px] mb-[8px]">
              <span className="font-inter font-medium text-[13px] text-[#141415]">
                {attempt.reviewer?.title || reviewerTitle || 'Exam'}
              </span>
              <Link
                to={`/dashboard/results/${attempt._id}`}
                className="font-inter font-medium text-[13px] text-[#6E43B9] shrink-0 hover:underline"
              >
                View
              </Link>
            </div>
            <div className="flex items-center gap-[16px] flex-wrap">
              <div>
                <p className="font-inter text-[11px] text-[#6C737F] mb-[1px]">Score</p>
                <ScorePill attempt={attempt} />
              </div>
              {attempt.timeTaken && (
                <div>
                  <p className="font-inter text-[11px] text-[#6C737F] mb-[1px]">Time</p>
                  <span className="font-inter text-[13px] text-[#6C737F]">{attempt.timeTaken}</span>
                </div>
              )}
              <div>
                <p className="font-inter text-[11px] text-[#6C737F] mb-[1px]">Date</p>
                <span className="font-inter text-[13px] text-[#6C737F]">
                  {formatDate(attempt.submittedAt || attempt.createdAt)}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
}
